import { DataPeriod } from '@prisma/client';
import { startOfDay, startOfMonth, startOfWeek } from 'date-fns';

export const getDateFromParams = (params: URLSearchParams | { [key: string]: string }): Date => {
  const dateParam = params instanceof URLSearchParams ? params.get('date') : params.date;
  const today = startOfDay(new Date());
  if (!dateParam) {
    return today;
  }
  const date = new Date(dateParam);
  return isNaN(date.getTime()) ? today : date;
};

export const getRangeFromParams = (params: URLSearchParams | { [key: string]: string }): DataPeriod => {
  const rangeParam = params instanceof URLSearchParams ? params.get('range') : params.range;
  if (!rangeParam || !Object.values(DataPeriod).includes(rangeParam as DataPeriod)) {
    return DataPeriod.Daily;
  }
  return rangeParam as DataPeriod;
};

export function dateToIsoStringIgnoringTimezone(date: Date) {
  // Get the timezone offset in minutes and convert to milliseconds
  const offset = date.getTimezoneOffset() * 60000;

  // Create a new date based on the original timestamp minus the offset
  const adjustedTimestamp = date.getTime() - offset;
  const adjustedDate = new Date(adjustedTimestamp);

  // Convert to ISO string
  return adjustedDate.toISOString();
}

export const toStartOfRange = (date: Date, range: DataPeriod): Date => {
  switch (range) {
    case DataPeriod.Daily:
      return startOfDay(date);
    case DataPeriod.Weekly:
      return startOfWeek(date, { weekStartsOn: 1 }); // Monday as week start
    case DataPeriod.Monthly:
      return startOfMonth(date);
  }
};
